/** @jsx jsx */
import { ClassAttributes, } from 'react';
import { jsx, } from '@emotion/core';
import styled from '@emotion/styled';
import { Rating, } from '@argo/ui-elements';
import { ConsumerReviewAndRating, Vehicle, } from '../../sew-core/types';
import { ConsumerRatings, } from '../../sew-common';

const Container = styled.div`
  width: 100%;
`;

const RatingContainer = styled.div`
  padding: 24px 0 16px 0;
  width: 100%;
`;

interface ConsumerRatingProps extends ClassAttributes<any> {
  consumerReviewAndRating: ConsumerReviewAndRating;
  vehicle: Vehicle;
}

export default ({ consumerReviewAndRating, vehicle, }: ConsumerRatingProps) => {
  const { consumerRating, } = consumerReviewAndRating;
  const ratings: Array<{ text: string; value: number }> = [];
  const lookupText = {
    valueRating: 'Value',
    qualityRating: 'Quality',
    reliabilityRating: 'Reliability',
    performanceRating: 'Performance',
    comfortRating: 'Comfort',
    stylingRating: 'Styling',
    overallRating: 'Overall',
  };

  // create an array of consumer Rating key and value except overall rating
  for (const ratingType in consumerRating) {
    if (ratingType !== 'overallRating') {
      ratings.push({
        text: lookupText[ratingType],
        value: parseFloat(consumerRating[ratingType] || 0),
      });
    }
  }
  ratings.sort((a, b) => b.value - a.value);

  if(consumerRating.overallRating === '' || consumerRating.overallRating === '0'){
    return(
      <Container>
        There are no ratings for this vehicle.
      </Container>
    )
  }

  return (
    <Container>
      <ConsumerRatings consumerReviewAndRating={consumerReviewAndRating} vehicle={vehicle} />
      <RatingContainer>
        {
          ratings.map((rating) => (<Rating key={`${rating.text}-${rating.value}`} type="Bar" subType="CategoryHorizontal" text={rating.text} rating={rating.value || 0} />))
        }
      </RatingContainer>
    </Container>
  );
};
